import type { FC, ReactNode } from 'react';
import { QStack } from '../../../QLayouts';

export const CustomFormContent: FC<{ children?: ReactNode }> = ({
  children,
}) => <QStack spacing="16px">{children}</QStack>;
CustomFormContent.displayName = 'FilterCustomFormContent';
